import { makeStyles } from '@mui/styles';
const deliveryTimeFrameStyles = makeStyles(({ palette: { success: { main, light }, }, }) => ({
    container: {
        border: `1px solid ${main}`,
        backgroundColor: light,
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px',
        marginTop: '16px',
    },
    icon: {
        color: main,
        marginRight: '5px',
    },
    text: {
        color: main,
    },
}), { name: 'Common_DeliveryTimeFrame' });
export default deliveryTimeFrameStyles;
//# sourceMappingURL=deliveryTimeFrame.styles.js.map